/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordStatisticRequest
 */
export interface RecordStatisticRequest {
    /**
     * 
     * @type {string}
     * @memberof RecordStatisticRequest
     */
    trackingId?: string;
}

/**
 * Check if a given object implements the RecordStatisticRequest interface.
 */
export function instanceOfRecordStatisticRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RecordStatisticRequestFromJSON(json: any): RecordStatisticRequest {
    return RecordStatisticRequestFromJSONTyped(json, false);
}

export function RecordStatisticRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordStatisticRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'trackingId': !exists(json, 'trackingId') ? undefined : json['trackingId'],
    };
}

export function RecordStatisticRequestToJSON(value?: RecordStatisticRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trackingId': value.trackingId,
    };
}

